import { connect } from 'react-redux';
import Component from './component';
import getSessionAction from '../../actions/session/get';
import getMaintenanceModeAction from '../../actions/maintenancemode/get';
import debug from '../../services/debug';

const mapStateToProps = (state) => ({
  session: state.session.get('data'),
  maintenancemode: state.maintenancemode.get('data'),
});

const mapDispatchToProps = (dispatch) => ({
  handleGetSession: async () => {
    debug('handleGetSession', 'app-maintenance');
    await dispatch(await getSessionAction());
  },
  handleGetGlobalMaintenanceMode: (auth) => {
    dispatch(getMaintenanceModeAction(auth));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
